import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import {
  ambulanceReducer,
  ambulanceReducerLocation,
  traumaCenterReducerLocation,
  onClickLatLngReducer,
  policeStationReducerLocation,
  poiReducerLocation,
} from "./locateAmbulanceReducer";
import { clearSosFormReducer } from "./ClearSosReducer";
import { empanelmentDetailReducer } from "./AdminEmpanelmentReducer";
import { accountSuspensionReducer } from "./AccountSuspensionReducer";
import {
  softwareNotificationReducer,
  networkProvidersReducer,
  testingAgenciesReducer,
  alertRulesReducer,
  organizationTypeReducer,
  ticketTypeReducer,
  getAmbulancesReducer,
  getNewsUpdateReducer,
  getLivePortsReducer,
  m2mServiceProviderReducer,
  simTypeReducer,
  getTraumaCentersReducer,
  AlertTypeReducer,
  UnreadNotificationReducer,
  getDistrictGeofenceReducer,
  getStateGeofenceReducer,
} from "./notificationReducer";
import {
  getAreaFenceReducer,
  getSosCategoriesReducer,
  getSosProvidersReducer,
  getSosZonesReducer,
  getSosMembersReducer,
  getCircularFenceReducer,
  getRouteFenceReducer,
  getGeofenceDevicesReducer,
} from "./addOnsReducer";
import {
  getStatesReducer,
  getDistrictsReducer,
  getAreasReducer,
} from "./locationSettingReducer";
import {
  getInstalledVehicleByStateReducer,
  getAlertsReducer,
  getNonWorkingSlotsReducer,
} from "./alertsReducer";
import accountTypeReducer from "./accountsReducer";
import notificationReducer from "./GetNotificationReducer";
import { manufacturerEmpanelmentReducer } from "./ManufacturerEmpanelmentReducer";
import { installedDetailedReducer } from "./InstalledDeviceReducer";
import { BgWalletReducer } from "./BgWalletReducer";
import { BgWalletAddOnReducer } from "./BgWalletReducer";
import {
  overSpeedReportReducer,
  reportStatsReducer,
  reportReducer,
  auditReportReducer,
  fencingReportReducer,
  alertReportReducer,
  logsReportReducer,
  offlineDeviceReportReducer,
  InvalidTicketReducer,
  NotificationReportReducer,
  OfflineDeviceMonthlyReportReducer,
} from "./ReportReducer";
import { dashBoardReducersData } from "./dashBoardReducer";
import { ManageRolesReducer } from "./manageRolesReducers";
import { ManageUsersReducer } from "./manageUsersReducers";
import { ManageCitizenReducer } from "./citizenUsersReducers";
import { ManageDevicesReducer, devicesModalTacReducer } from "./devicesReducer";
import { ManagesDevicesReducer } from "./managedevicesReducer";
import { MemberListReducer } from "./memberlistReducer";
import {
  ComplaintReducer,
  CustomerTicketListApiReducer,
  CustomerTicketListReducer,
  CustomerVehicleDetailsReducer,
  CustomerVehiclesListReducer,
  offlineIntimationReducer,
  vehicleOwnerNotificationReducer,
} from "./ComplaintReducer";
import { EmpanelmentProcessReducer } from "./empanelmentProcessReducer";
import { SystemLogReducer } from "./SystemLogReducer";
import {
  getAssetGroupDropdownReducer,
  getDailyReportReducer,
  getOrganizationAreafenceReducer,
  getPanicHistoryReportReducer,
  getSchoolAlertReportReducer,
  getSchoolAreafenceReportReducer,
  getSchoolOverspeedReportReducer,
  getStoppageReportsReducer,
  getTripReportReducer,
  getUserByAccountIdDropdownReducer,
  getVehicleDropdownReducer,
  tripConfigurationReducer,
  tripConfigVehicleAssocReducer,
  tripRulesReducer,
} from "./schoolPanelReducer";
import { PoiCategoryReducer } from "./PoiReducer";
import { updatePoiStatusReducer } from "./PoiReducer";
import { updateMainPoiStatusReducer } from "./PoiReducer";
import { PoiReducer } from "./PoiReducer";
import { poiCategoryDropdownReducer, updatePoiIconReducer } from "./PoiReducer";
import { VehicleIconReducerByID } from "./VehicleIconReducer";
import { packageSettingReducer } from "./packageSettingReducer";

const rootReducer = combineReducers({
  auth,
  message,
  ambulanceReducer,
  ambulanceReducerLocation,
  traumaCenterReducerLocation,
  onClickLatLngReducer,
  clearSosFormReducer,
  empanelmentDetailReducer,
  policeStationReducerLocation,
  accountSuspensionReducer,
  notificationReducer,
  softwareNotificationReducer,
  accountTypeReducer,
  manufacturerEmpanelmentReducer,
  installedDetailedReducer,
  BgWalletReducer,
  BgWalletAddOnReducer,
  networkProvidersReducer,
  testingAgenciesReducer,
  alertRulesReducer,
  organizationTypeReducer,
  ticketTypeReducer,
  getAmbulancesReducer,
  overSpeedReportReducer,
  getNewsUpdateReducer,
  getLivePortsReducer,
  m2mServiceProviderReducer,
  dashBoardReducersData,
  simTypeReducer,
  getTraumaCentersReducer,
  getInstalledVehicleByStateReducer,
  ManageRolesReducer,
  ManageUsersReducer,
  ManageCitizenReducer,
  ManageDevicesReducer,
  ManagesDevicesReducer,
  MemberListReducer,
  getAreaFenceReducer,
  getSosCategoriesReducer,
  getSosProvidersReducer,
  getSosZonesReducer,
  getSosMembersReducer,
  getCircularFenceReducer,
  getRouteFenceReducer,
  ComplaintReducer,
  EmpanelmentProcessReducer,
  getGeofenceDevicesReducer,
  getStatesReducer,
  getDistrictsReducer,
  getAreasReducer,
  getAlertsReducer,
  getNonWorkingSlotsReducer,
  SystemLogReducer,
  reportStatsReducer,
  reportReducer,
  auditReportReducer,
  fencingReportReducer,
  alertReportReducer,
  logsReportReducer,
  devicesModalTacReducer,
  getVehicleDropdownReducer,
  getAssetGroupDropdownReducer,
  getStoppageReportsReducer,
  getDailyReportReducer,
  getTripReportReducer,
  getSchoolAlertReportReducer,
  getSchoolAreafenceReportReducer,
  getSchoolOverspeedReportReducer,
  updateMainPoiStatusReducer,
  updatePoiStatusReducer,
  PoiCategoryReducer,
  PoiReducer,
  poiCategoryDropdownReducer,
  getUserByAccountIdDropdownReducer,
  updatePoiIconReducer,
  getPanicHistoryReportReducer,
  offlineDeviceReportReducer,
  CustomerTicketListReducer,
  CustomerVehicleDetailsReducer,
  CustomerTicketListApiReducer,
  CustomerVehiclesListReducer,
  offlineIntimationReducer,
  InvalidTicketReducer,
  poiReducerLocation,
  vehicleOwnerNotificationReducer,
  AlertTypeReducer,
  NotificationReportReducer,
  UnreadNotificationReducer,
  VehicleIconReducerByID,
  OfflineDeviceMonthlyReportReducer,
  getOrganizationAreafenceReducer,
  tripConfigurationReducer,
  tripRulesReducer,
  tripConfigVehicleAssocReducer,
  packageSettingReducer,
  getDistrictGeofenceReducer,
  getStateGeofenceReducer,
});

export default rootReducer;
